module.exports = __webpack_public_path__ + "static/media/400015_01.6a19f18b.png";